import { useEffect, useMemo, useState } from 'react';
import { useSessionStorage } from 'react-use';
import { useMeContext } from 'modules/me';
import { getParsedJwt, getTokens } from 'modules/oauth/tokenStore';
import { useSessionContext } from 'modules/session';
import { isWithinAnotherApp } from 'containerApp';

export const useSubstituteUser = (): { isSubstituteUser: boolean } => {
  const token = getTokens();
  const value = getParsedJwt(token?.accessToken);
  const accountType = value?.['replicon:account_type'];
  const me = useMeContext();
  const { interactiveSession } = useSessionContext();
  const [isSubstituteUser, setIsSubstituteUser] = useState<boolean>(false);
  const [isSessionStarted, setIsSessionStarted] = useSessionStorage(
    `${me?.id}_isSessionStarted`,
    false
  );

  useEffect(() => {
    const sessionStarted = async (event: any) => {
      sessionStorage.setItem('ACTUALUSERURI', event?.actualUser);
      setIsSessionStarted(true);
    };

    const sessionEnded = async () => {
      sessionStorage.removeItem('ACTUALUSERURI');
      setIsSessionStarted(false);
    };

    const session = interactiveSession.current;

    session?.addEventListener('started', sessionStarted as EventListener);
    session?.addEventListener('ended', sessionEnded as EventListener);

    return () => {
      session?.removeEventListener('started', sessionStarted as EventListener);
      session?.removeEventListener('ended', sessionEnded as EventListener);
    };
  }, [interactiveSession, setIsSessionStarted]);

  useEffect(() => {
    const checkIsSubstituteUser = () => {
      const actualUserUri = sessionStorage.getItem('ACTUALUSERURI');

      if (
        actualUserUri &&
        actualUserUri !== String(undefined) &&
        me?.id &&
        isSessionStarted &&
        accountType === 'urn:replicon-saas:account-type:trial' &&
        !isWithinAnotherApp()
      ) {
        return actualUserUri !== me?.id;
      } else {
        return false;
      }
    };
    const isSubstituteUser = checkIsSubstituteUser();
    setIsSubstituteUser(isSubstituteUser);
  }, [accountType, isSessionStarted, me?.id]);

  return useMemo(
    () => ({
      isSubstituteUser
    }),
    [isSubstituteUser]
  );
};
